import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { JobWizard } from "@/components/jobs/job-wizard";
import { useDict } from "@/lib/i18n/context";

export function NewJobPage() {
  const t = useDict();
  return (
    <div className="space-y-6">
      <Link
        to="/jobs"
        className="inline-flex items-center gap-1 text-sm text-muted hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4 rtl:rotate-180" /> {t.jobs.backToJobs}
      </Link>
      <div>
        <h1 className="text-2xl font-bold">{t.jobs.newTitle}</h1>
        <p className="text-muted">{t.jobs.newSubtitle}</p>
      </div>
      <JobWizard />
    </div>
  );
}
